import React from 'react'
import Header from '../Components/Header';
import { Link } from 'react-router';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css';
import Sidebar from '../Components/Sidebar';

export default function Suppliers() {
  return (
     <div id="dashboard-root" 
          className="flex min-h-[1000px] w-full">
            {/* <!-- Sidebar --> */}
            <Sidebar />
            {/* <!-- Main Content --> */}
            <main id="main-content" className="flex-1 px-10 py-8">
              {/* <!-- Header --> */}
    <Header title="Supplier" />
   <div id="suppliers-page" className="mb-6">
                    <div className="flex justify-between items-center mb-6">
                        <div>
                            <h1 className="text-2xl font-bold text-gray-800">Suppliers</h1>
                            <p className="text-gray-600">Manage your medical product suppliers</p>
                        </div>
                        <div className="flex space-x-3">
                            <button className="bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm font-medium text-gray-700 flex items-center">
                                <i className="fa-solid fa-filter mr-2"></i>
                                Filter
                            </button>
                            <button className="bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm font-medium text-gray-700 flex items-center">
                                <i className="fa-solid fa-download mr-2"></i>
                                Export
                            </button>
                            <Link to="/supplier/add-supplier" id="add-supplier-btn" class="bg-primary-600 hover:bg-primary-700 text-white rounded-lg px-4 py-2 text-sm font-medium flex items-center">
                                <i className="fa-solid fa-plus mr-2"></i>
                                Add Supplier
                            </Link>
                        </div>
                    </div>

                    <div className="bg-white rounded-lg shadow overflow-hidden">
                        <div className="p-4 border-b flex items-center justify-between">
                            <div className="flex items-center">
                                <input type="checkbox" className="rounded text-primary-600 mr-3" />
                                <span className="text-sm text-gray-600">Select All</span>
                            </div>
                            <div className="relative">
                                <input type="text" placeholder="Search suppliers..." className="border rounded-lg px-3 py-2 text-sm w-64" />
                                <i className="fa-solid fa-search absolute right-3 top-2.5 text-gray-400"></i>
                            </div>
                        </div>
                        <div className="overflow-x-auto">
                            {
                            <table className="w-full">
                                <thead className="bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    <tr>
                                        <th className="p-4 w-10"></th>
                                        <th className="p-4">Supplier</th>
                                        <th className="p-4">Contact Person</th>
                                        <th className="p-4">Email</th>
                                        <th className="p-4">Phone</th>
                                        <th className="p-4">Products</th>
                                        <th className="p-4">Status</th>
                                        <th className="p-4">Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                    <tr className="hover:bg-gray-50">
                                        <td className="p-4">
                                            <input type="checkbox" className="rounded text-primary-600" />
                                        </td>
                                        <td className="p-4">
                                            <div className="flex items-center">
                                                <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center mr-3">
                                                    <i className="fa-solid fa-building text-primary-500"></i>
                                                </div>
                                                <div>
                                                    <div className="font-medium text-gray-800">MediSupply Inc.</div>
                                                    <div className="text-xs text-gray-500">Medical Equipment</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="p-4 text-gray-600">Sarah Johnson</td>
                                        <td className="p-4 text-gray-600">sarah@medisupply.com</td>
                                        <td className="p-4 text-gray-600">+1 (555) 123-4567</td>
                                        <td className="p-4 text-gray-600">42</td>
                                        <td className="p-4">
                                            <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">Active</span>
                                        </td>
                                        <td className="p-4">
                                            <div className="flex space-x-2">
                                                <Link to="/supplier/edit-supplier" class="text-gray-500 hover:text-primary-600">
                                                    <i className="fa-solid fa-pencil"></i>
                                                </Link>
                                                <button className="text-gray-500 hover:text-red-600">
                                                    <i className="fa-solid fa-trash"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="hover:bg-gray-50">
                                        <td className="p-4">
                                            <input type="checkbox" className="rounded text-primary-600" />
                                        </td>
                                        <td className="p-4">
                                            <div className="flex items-center">
                                                <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center mr-3">
                                                    <i className="fa-solid fa-building text-primary-500"></i>
                                                </div>
                                                <div>
                                                    <div className="font-medium text-gray-800">PharmaWholesale Ltd.</div>
                                                    <div className="text-xs text-gray-500">Pharmaceuticals</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="p-4 text-gray-600">Michael Chen</td>
                                        <td className="p-4 text-gray-600">michael@pharmawholesale.com</td>
                                        <td className="p-4 text-gray-600">+1 (555) 987-6543</td>
                                        <td className="p-4 text-gray-600">128</td>
                                        <td className="p-4">
                                            <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">Active</span>
                                        </td>
                                        <td className="p-4">
                                            <div className="flex space-x-2">
                                                <Link to="/supplier/edit-supplier" class="text-gray-500 hover:text-primary-600">
                                                    <i className="fa-solid fa-pencil"></i>
                                                </Link>
                                                <button className="text-gray-500 hover:text-red-600">
                                                    <i className="fa-solid fa-trash"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="hover:bg-gray-50">
                                        <td className="p-4">
                                            <input type="checkbox" className="rounded text-primary-600" />
                                        </td>
                                        <td className="p-4">
                                            <div className="flex items-center">
                                                <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center mr-3">
                                                    <i className="fa-solid fa-building text-primary-500"></i>
                                                </div>
                                                <div>
                                                    <div className="font-medium text-gray-800">LabEquip Co.</div>
                                                    <div className="text-xs text-gray-500">Laboratory Equipment</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="p-4 text-gray-600">Emily Rodriguez</td>
                                        <td className="p-4 text-gray-600">emily@labequip.com</td>
                                        <td className="p-4 text-gray-600">+1 (555) 456-7890</td>
                                        <td className="p-4 text-gray-600">56</td>
                                        <td className="p-4">
                                            <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">Active</span>
                                        </td>
                                        <td className="p-4">
                                            <div className="flex space-x-2">
                                                <Link to="/supplier/edit-supplier" class="text-gray-500 hover:text-primary-600">
                                                    <i className="fa-solid fa-pencil"></i>
                                                </Link>
                                                <button className="text-gray-500 hover:text-red-600">
                                                    <i className="fa-solid fa-trash"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="hover:bg-gray-50">
                                        <td className="p-4">
                                            <input type="checkbox" className="rounded text-primary-600" />
                                        </td>
                                        <td className="p-4">
                                            <div className="flex items-center">
                                                <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center mr-3">
                                                    <i className="fa-solid fa-building text-primary-500"></i>
                                                </div>
                                                <div>
                                                    <div className="font-medium text-gray-800">MedTech Innovations</div>
                                                    <div className="text-xs text-gray-500">Medical Devices</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="p-4 text-gray-600">David Wilson</td>
                                        <td className="p-4 text-gray-600">david@medtech.com</td>
                                        <td className="p-4 text-gray-600">+1 (555) 234-5678</td>
                                        <td className="p-4 text-gray-600">31</td>
                                        <td className="p-4">
                                            <span className="px-2 py-1 bg-yellow-100 text-yellow-800 rounded-full text-xs">On Hold</span>
                                        </td>
                                        <td className="p-4">
                                            <div className="flex space-x-2">
                                                <Link to="/supplier/edit-supplier" class="text-gray-500 hover:text-primary-600">
                                                    <i className="fa-solid fa-pencil"></i>
                                                </Link>
                                                <button className="text-gray-500 hover:text-red-600">
                                                    <i className="fa-solid fa-trash"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="hover:bg-gray-50">
                                        <td className="p-4">
                                            <input type="checkbox" className="rounded text-primary-600" />
                                        </td>
                                        <td className="p-4">
                                            <div className="flex items-center">
                                                <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center mr-3">
                                                    <i className="fa-solid fa-building text-primary-500"></i>
                                                </div>
                                                <div>
                                                    <div className="font-medium text-gray-800">Global Health Supplies</div>
                                                    <div className="text-xs text-gray-500">Medical Consumables</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="p-4 text-gray-600">Jessica Brown</td>
                                        <td className="p-4 text-gray-600">jessica@globalhealth.com</td>
                                        <td className="p-4 text-gray-600">+1 (555) 345-6789</td>
                                        <td className="p-4 text-gray-600">84</td>
                                        <td className="p-4">
                                            <span className="px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs">Inactive</span>
                                        </td>
                                        <td className="p-4">
                                            <div className="flex space-x-2">
                                                <Link to="/supplier/edit-supplier" class="text-gray-500 hover:text-primary-600">
                                                    <i className="fa-solid fa-pencil"></i>
                                                </Link>
                                                <button className="text-gray-500 hover:text-red-600">
                                                    <i className="fa-solid fa-trash"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            || <Skeleton count={10} />}
                        </div>
                        {
                        <div className="p-4 border-t flex items-center justify-between">
                            <div className="text-sm text-gray-600">
                                Showing 1 to 5 of 18 entries
                            </div>
                            <div className="flex space-x-1">
                                <button className="px-3 py-1 rounded border text-gray-600 hover:bg-gray-50">Previous</button>
                                <button className="px-3 py-1 rounded border bg-primary-50 text-primary-600 font-medium">1</button>
                                <button className="px-3 py-1 rounded border text-gray-600 hover:bg-gray-50">2</button>
                                <button className="px-3 py-1 rounded border text-gray-600 hover:bg-gray-50">3</button>
                                <button className="px-3 py-1 rounded border text-gray-600 hover:bg-gray-50">Next</button>
                            </div>
                        </div>
                        || <Skeleton count={5} />}
                    </div>
                </div>
                </main>
                </div>
  )
}
